import React from 'react'
import styled from 'styled-components'
import { Slider, SliderMarker } from '@reach/slider'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

import '@reach/slider/styles.css'
import { t } from 'src/lib/i18n-react'
let StyledSlider = styled(Slider)`
  padding-left: 10px;
  padding-right: 10px;
  width: 93% !important;
  max-width: 93%;
  padding-top: 12px !important;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  [data-reach-slider-track][data-orientation='horizontal'] {
    background: ${(props) => props.theme.colors.gray88};
    height: 8px;
    border-radius: 10px;
  }
  [data-reach-slider-track-highlight] {
    background: #ea3d6d;
    transition: width 0.25s ease-in-out;
  }
  [data-reach-slider-handle] {
    height: 30px;
    width: 30px;
    border-radius: 100%;
    border-color: #ea3d6d;
    transition: left 0.25s ease-in-out;
  }
  [data-reach-slider-marker] {
    height: 3px;
    width: 3px;
  }
  [data-reach-slider-marker][data-state='over-value'],
  [data-reach-slider-marker][data-state='under-value'],
  [data-reach-slider-marker][data-state='at-value'] {
    background-color: white;
  }
  [data-reach-slider-marker][data-value="${(props) => props.min}"] {
    left: 1% !important;
  }
  [data-reach-slider-marker][data-value="${(props) => props.max}"] {
    left: 99% !important;
  }
`
const LevelSlider = ({ levels, selectedLevelIndex, onChange }) => {
  const max = levels.length

  const handleChange = (newValue) => {
    onChange(newValue)
  }

  return (
    <StyledSlider
      min={0}
      max={max - 1}
      value={selectedLevelIndex}
      step={1}
      onChange={handleChange}
      getAriaValueText={() =>
        `${levels[selectedLevelIndex].code} ${levels[selectedLevelIndex].label}`
      }
      getAriaLabel={() => t('Choose your level')}
    >
      {levels.map((level, index) => (
        <SliderMarker key={index} value={index}>
          <Box
            sx={{
              textTransform: 'uppercase',
            }}
            fontWeight="semibold"
            textTransform="uppercase"
            marginLeft="-8px"
            marginTop="2x"
          >
            {index % 2 === 0 ? level.code : ''}
          </Box>
        </SliderMarker>
      ))}
    </StyledSlider>
  )
}

LevelSlider.propTypes = {
  levels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      code: PropTypes.string,
      label: PropTypes.string,
      start: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
  selectedLevelIndex: PropTypes.number,
}

export default LevelSlider
